import React from 'react';
import { AlertIcon, ClockIcon } from './icons/CraftIcons';
import { CountdownDigits } from './CountdownDigits';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 w-full bg-crimson-dark text-crimson-tint shadow-[0_2px_10px_rgba(0,0,0,0.18)]" data-id="element-428" data-mp="3ct3cf2xevk9b">
      <div className="mx-auto flex max-w-[1320px] flex-col items-center justify-center gap-2 px-4 py-2 text-center sm:flex-row sm:gap-3 sm:py-1.5" data-id="element-429" data-mp="32x0de5xuw1ql">
        <div className="flex items-center gap-2" data-id="element-430" data-mp="2yw6phckeymxp">
          <AlertIcon className="h-4 w-4 shrink-0" data-id="element-431" data-mp="2u4oowpmayod9" />
          <p className="text-[11px] font-semibold leading-snug sm:text-xs" data-id="element-432" data-mp="2u3wtbespgqmz">
            ATTENTION: You are currently paying{' '}
            <strong className="font-extrabold text-white" data-id="element-433" data-mp="2p3hba9xhauyo">1,200% more</strong> for single patterns.
            This <strong className="font-extrabold text-white" data-id="element-434" data-mp="2k4o1arhehm39">$616 bundle</strong> closes forever
            when the timer hits zero.
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-1.5 rounded-md border border-white/35 bg-black/25 px-2.5 py-1" data-id="element-435" data-mp="2b73xpbw2fdph">
          <ClockIcon className="h-3.5 w-3.5" data-id="element-436" data-mp="1rvzp15nkeft4" />
          <CountdownDigits className="text-xs text-white" data-id="element-437" data-mp="1woj303q5zcyg" />
        </div>
      </div>
    </div>;
}